export default __webpack_public_path__ + "static/media/team-marc.d855fa15.jpg";